// Backed by GET /api/v1/records/champions?simulator= — see srl-be RecordController.getChampions.
// The endpoint returns flat rows, one per season championship (a driver with 3 titles appears 3
// times); this collapses them into one entry per driver, ranked by title count.

/**
 * Collapses the flat title rows into one entry per champion driver, ranked by number of titles.
 *
 * @param {Array} rows flat title rows, as returned by fetchChampions
 * @param {string} simulatorName simulator to keep, e.g. "iRacing"
 * @returns {Array} [{ driverId, driverName, driverSeoUrl, driverImage, accent, titles, titleCount, latestYear }]
 */
export function groupChampionsByDriver(rows, simulatorName) {
  const byDriver = new Map();

  (rows || [])
    .filter((row) => row.simulator === simulatorName)
    .forEach((row) => {
      const existing = byDriver.get(row.driverId);
      const title = {
        seasonId: row.seasonId,
        seasonName: row.seasonName,
        seasonShortName: row.seasonShortName,
        year: row.year,
        team: row.team,
      };

      if (existing) {
        existing.titles.push(title);
      } else {
        byDriver.set(row.driverId, {
          driverId: row.driverId,
          driverName: row.driverName,
          driverSeoUrl: row.driverSeoUrl,
          driverImage: row.driverImage,
          titles: [title],
        });
      }
    });

  return [...byDriver.values()]
    .map((champion) => {
      // Newest title first — it also supplies the tile's accent colour and the team shown next
      // to the driver's name.
      const titles = [...champion.titles].sort(
        (a, b) => b.year - a.year || b.seasonId - a.seasonId,
      );
      return {
        ...champion,
        titles,
        titleCount: titles.length,
        latestYear: titles[0].year,
        latestTeam: titles[0].team,
        accent: titles[0].team?.color,
      };
    })
    .sort(
      (a, b) =>
        b.titleCount - a.titleCount ||
        b.latestYear - a.latestYear ||
        a.driverName.localeCompare(b.driverName, "uk"),
    );
}
